var render = function render(){var _vm=this,_c=_vm._self._c;return _c('list-table',{attrs:{"url":_vm.url,"title":"درخواست های شارژ","fields":_vm.fields,"params":_vm.params,"detailUrl":_vm.detailUrl}})
}
var staticRenderFns = []

export { render, staticRenderFns }